// 这是全局混淆的函数
export default {
  install (Vue) {
    Vue.mixin({
      methods: {
        goBackMixin () {
          if (/micromessenger/.test(navigator.userAgent.toLowerCase())) {
            if (window.__wxjs_environment === 'miniprogram') {
              window.wx.miniProgram.navigateBack()
              return
            }
          }
          let oldHref = this.$route.fullPath
          this.$router.go(-1)
          // 兼容没有反应强制跳转
          let timer = setTimeout(() => {
            let newHref = this.$route.fullPath
            if (newHref === oldHref) this.$router.push('/home')
            clearTimeout(timer)
          }, 200)
        }
      }
    })
  }
}



// WEBPACK FOOTER //
// ./src/mixin/common/index.js